<template>
    <div class="dialog-screen">
        <div name="tab-btn" class="simple-row clearfix">
            <div class="left">
            </div>
            <div class="right">
                <span class="font-red mr5" v-if="hintMsg != null && hintMsg != ''">提示：{{hintMsg}}</span>
                <div class="swb-btn swb-btn-small swb-btn-primary mr5" @click="setChargeItemBatch()">批量设置收费项</div>
            </div>
        </div>
        <div class="table-layout">
            <el-table class="thin" :data="pageServcImpList" :height="tableHeight" ref="servcImpInfoTable" border style="width: 100%; font-size: 12px" @selection-change="handleSelectionChange" :row-class-name="markSelectedRowClassName">
                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column prop="rowNo" label="行号" width="60" align="center" fixed></el-table-column>
                <el-table-column prop="failed" label="执行状态" width="60" align="center" fixed="left" v-show="startFlag">
                    <template slot-scope="rows">
                        <div v-if="rows.row.failed != null">
                            <span v-if="rows.row.failed" style="color: red;font-size: 20px">×</span>
                            <span v-else style="color: green;font-size: 20px">√</span>
                        </div>
                        <span v-else class="font-gray3">未执行</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failDesc" label="失败描述" width="260" align="left" fixed="left" v-show="startFlag">
                    <template slot-scope="rows">
                        <span v-if="rows.row.errorMsg != null && rows.row.errorMsg != ''">{{rows.row.errorMsg}}</span>
                        <span v-else>{{rows.row.failDesc}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="服务名称" prop="name" width="200">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.name.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 99%" v-model="rows.row.name" :title="rows.row.validateInfo.name.errorMsg"/>
                        <input type="text" v-else style="width:99%" @change="commonChangeEvent" v-model="rows.row.name"/>
                    </template>
                </el-table-column>
                <el-table-column label="服务标题" prop="title" width="200">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.title.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 190px" v-model="rows.row.title"
                               :title="rows.row.validateInfo.title.errorMsg"/>
                        <input type="text" v-else style="width:190px" @change="commonChangeEvent" v-model="rows.row.title"/>
                    </template>
                </el-table-column>
                <el-table-column label="服务类型" prop="servcTypeName" width="200">
                    <template slot-scope="rows">
                        <div style="background-color: #edd28b; width: 99%" v-if="!rows.row.validateInfo.servcTypeName.validateOk" :title="rows.row.validateInfo.servcTypeName.errorMsg">
                            <el-select v-model="rows.row.servcTypeName" @change="commonChangeEvent" class="select-warn">
                                <el-option v-for="item in servcTypeTextList" :key="item.label" :label="item.label" :value="item.label"/>
                            </el-select>
                        </div>
                        <el-select v-model="rows.row.servcTypeName" @change="commonChangeEvent" v-else>
                            <el-option v-for="item in servcTypeTextList" :key="item.label" :label="item.label" :value="item.label"/>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="服务用途" prop="comnOnlyFlag" width="200">
                    <template slot-scope="rows">
                        <div style="background-color: #edd28b; width: 99%" v-if="!rows.row.validateInfo.comnOnlyFlag.validateOk" :title="rows.row.validateInfo.comnOnlyFlag.errorMsg">
                            <el-select v-model="rows.row.comnOnlyFlag" @change="commonChangeEvent" class="select-warn">
                                <el-option v-for="item in comnOnlyFlagList" :key="item.label" :label="item.label" :value="item.label"/>
                            </el-select>
                        </div>
                        <el-select v-model="rows.row.comnOnlyFlag" @change="commonChangeEvent" v-else>
                            <el-option v-for="item in comnOnlyFlagList" :key="item.label" :label="item.label" :value="item.label"/>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="规格名称" prop="specName" width="200">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.specName.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 99%" v-model="rows.row.specName"
                               :title="rows.row.validateInfo.specName.errorMsg"/>
                        <input type="text" v-else style="width:99%" @change="commonChangeEvent" v-model="rows.row.specName"/>
                    </template>
                </el-table-column>
                <el-table-column label="规格说明" prop="fixedSpec" width="200">
                    <template slot-scope="rows">
                        <input type="text" v-if="!rows.row.validateInfo.fixedSpec.validateOk" @change="commonChangeEvent" style="background-color: #edd28b; width: 99%" v-model="rows.row.fixedSpec"
                               :title="rows.row.validateInfo.fixedSpec.errorMsg"/>
                        <input type="text" v-else style="width:99%" @change="commonChangeEvent" v-model="rows.row.fixedSpec"/>
                    </template>
                </el-table-column>
                <el-table-column label="上门费(元)" prop="toDoorFee" width="150" align="right">
                    <template slot-scope="rows">
                        <input type="text" class="align-right" v-if="!rows.row.validateInfo.toDoorFee.validateOk" min="0" @change="commonChangeEvent" style="background-color: #edd28b; width: 99%" v-model.number="rows.row.toDoorFee"
                               :title="rows.row.validateInfo.toDoorFee.errorMsg"/>
                        <input type="text" class="align-right" v-else style="width:99%" @change="commonChangeEvent" min="0" v-model.number="rows.row.toDoorFee"/>
                    </template>
                </el-table-column>
                <el-table-column label="参考人工费(元)" prop="workHourFee" width="150" align="right">
                    <template slot-scope="rows">
                        <input type="text" class="align-right" style="width:99%" @change="commonChangeEvent" min="0" v-model.number="rows.row.workHourFee"/>
                    </template>
                </el-table-column>
                <el-table-column label="服务费(元)" prop="generallFee" width="150" align="right">
                    <template slot-scope="rows">
                        <input type="text" class="align-right" v-if="!rows.row.validateInfo.generallFee.validateOk" min="0" @change="commonChangeEvent" style="background-color: #edd28b; width: 99%" v-model.number="rows.row.generallFee"
                               :title="rows.row.validateInfo.generallFee.errorMsg"/>
                        <input type="text" class="align-right" v-else style="width:99%" min="0" @change="commonChangeEvent" v-model.number="rows.row.generallFee"/>
                    </template>
                </el-table-column>
                <el-table-column label="要求质保时长(天)" prop="wrntPeriod" width="150" align="right">
                    <template slot-scope="rows">
                        <input type="text" class="align-right" v-if="!rows.row.validateInfo.wrntPeriod.validateOk" min="0" @change="commonChangeEvent" style="background-color: #edd28b; width: 99%" v-model.number="rows.row.wrntPeriod"
                               :title="rows.row.validateInfo.wrntPeriod.errorMsg"/>
                        <input type="text" class="align-right" v-else style="width:99%" min="0" @change="commonChangeEvent" v-model.number="rows.row.wrntPeriod"/>
                    </template>
                </el-table-column>
                <el-table-column label="要求响应时长(分钟)" prop="rspTimeMi" width="150" align="right">
                    <template slot-scope="rows">
                        <input type="text" class="align-right" v-if="!rows.row.validateInfo.rspTimeMi.validateOk" min="0" @change="commonChangeEvent" style="background-color: #edd28b; width: 99%" v-model.number="rows.row.rspTimeMi"
                               :title="rows.row.validateInfo.rspTimeMi.errorMsg"/>
                        <input type="text" class="align-right" v-else style="width:99%" min="0" @change="commonChangeEvent" v-model.number="rows.row.rspTimeMi"/>
                    </template>
                </el-table-column>
                <el-table-column label="要求到达时长(分钟)" prop="arriveTimeMi" width="150" align="right">
                    <template slot-scope="rows">
                        <input type="text" class="align-right" v-if="!rows.row.validateInfo.arriveTimeMi.validateOk" min="0" @change="commonChangeEvent" style="background-color: #edd28b; width: 99%"
                               v-model.number="rows.row.arriveTimeMi"
                               :title="rows.row.validateInfo.arriveTimeMi.errorMsg"/>
                        <input type="text" class="align-right" v-else style="width:99%" min="0" @change="commonChangeEvent" v-model.number="rows.row.arriveTimeMi"/>
                    </template>
                </el-table-column>
                <el-table-column label="要求维修时长(分钟)" prop="repairedTimeMi" width="150" align="right">
                    <template slot-scope="rows">
                        <input type="text" class="align-right" v-if="!rows.row.validateInfo.repairedTimeMi.validateOk" min="0" @change="commonChangeEvent" style="background-color: #edd28b; width: 99%"
                               v-model.number="rows.row.repairedTimeMi"
                               :title="rows.row.validateInfo.repairedTimeMi.errorMsg"/>
                        <input type="text" class="align-right" v-else style="width:99%" min="0" @change="commonChangeEvent" v-model.number="rows.row.repairedTimeMi"/>
                    </template>
                </el-table-column>
                <el-table-column label="电话回询时限(分钟)" prop="telCallTimeMi" width="150" align="right">
                    <template slot-scope="rows">
                        <input type="text" class="align-right" v-if="!rows.row.validateInfo.telCallTimeMi.validateOk" min="0" @change="commonChangeEvent" style="background-color: #edd28b; width: 99%"
                               v-model.number="rows.row.telCallTimeMi"
                               :title="rows.row.validateInfo.telCallTimeMi.errorMsg"/>
                        <input type="text" class="align-right" v-else style="width:99%" min="0" @change="commonChangeEvent" v-model.number="rows.row.telCallTimeMi"/>
                    </template>
                </el-table-column>
                <el-table-column label="配件名称" prop="accName" width="200">
                    <template slot-scope="rows">
                        <input type="text" @change="commonChangeEvent" v-model="rows.row.accName"/>
                    </template>
                </el-table-column>
                <el-table-column label="配件规格" prop="accSpec" width="200">
                    <template slot-scope="rows">
                        <input type="text" @change="commonChangeEvent" v-model="rows.row.accSpec"/>
                    </template>
                </el-table-column>
                <el-table-column label="价格下限(元)" prop="salePrice" width="100" align="right">
                    <template slot-scope="rows">
                        <input class="align-right" type="text" @change="commonChangeEvent" min="0" v-model.number="rows.row.accPrice" style="width: 90px"/>
                    </template>
                </el-table-column>
                <el-table-column label="价格上限(元)" prop="accPrice2" width="100" align="right">
                    <template slot-scope="rows">
                        <input class="align-right" type="text" @change="commonChangeEvent" min="0" v-model.number="rows.row.accPrice2" style="width: 90px"/>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="rows">
                        <a class="swb-btn-link" @click="selectChargeItem(rows.row.rowNo)">收费项</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="clearfix">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10" @click="downloadServcImpModel">导出全部</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="doServcImpModelImport">执行导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="validateServcImpModel()">检查</div>
        </div>
    </div>

</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {openServcTypeChargeItemListSelect} from '../categ/selectDlg'

    import servcApi from '../../api/servc'

    export default {
        name: 'swb-servc-imp-check',
        desc: '服务项目导入检查',
        props: ['fileObj', 'rootHeight', 'theDlg'],
        data: function () {
            return {
                tableHeight: 0,
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: [15, 50, 100, 200],// 特殊页面处理
                pageServcImpList: {},
                servcImpDto: {
                    impInfoList: []
                },
                isOk: false,
                theLoading: null,
                multipleSelection: [],
                retailerInfo: null,
                max_quantity_per_item: 500,
                startFlag: false, // 标记是否已开始逐条执行
                nextIndex: 0,
                checkNextIndex: 0,
                servcTypeTextList: [],
                comnOnlyFlagList: [{value: "维保服务", label: "维保服务"}, {value: "常规服务", label: "常规服务"}],
                hintMsg: '注意：批量设置收费项操作仅能选择同一服务类型的服务项目！'
            }
        },
        watch: {
            rootHeight(newVal, oldVal){
                this.recalcTableHeight();
            }
        },
        created: function () {
            this.recalcTableHeight();
            //
            let self = this;
            self.getServcTypeTextList();
            //
            let theLoading = MsgBox.loading();
            let servcImpInfoList = this.fileObj.extra.servcImpInfoList || [];
            servcImpInfoList.forEach(function (el) {
                el.validateInfo = {
                    name: {validateOk: true},
                    title: {validateOk: true},
                    servcTypeName: {validateOk: true},
                    comnOnlyFlag: {validateOk: true},
                    specName: {validateOk: true},
                    fixedSpec: {validateOk: true},
                    toDoorFee: {validateOk: true},
                    workHourFee: {validateOk: true},
                    generallFee: {validateOk: true},
                    wrntPeriod: {validateOk: true},
                    rspTimeMi: {validateOk: true},
                    arriveTimeMi: {validateOk: true},
                    repairedTimeMi: {validateOk: true},
                    telCallTimeMi: {validateOk: true},
                    accName: {validateOk: true},
                    accSpec: {validateOk: true},
                    accPrice: {validateOk: true},
                    accPrice2: {validateOk: true}
                };
            });
            this.servcImpDto.impInfoList = servcImpInfoList;
            //
            this.pageSize = this.pageSizes.first();
            self.checkData();
            self.setPageServcImpInfoList();
            theLoading.close();
        },
        methods: {
            recalcTableHeight(){
                this.tableHeight = this.rootHeight - 60 - 42;
            },
            // 选中行
            markSelectedRowClassName(row){
                return this.multipleSelection.find(function (tmpRow) {
                    return tmpRow.rowNo == row.rowNo;
                }) != null ? 'selected-row' : '';
            },
            getServcTypeTextList: function () {
                let servcTypeTextList = [];
                let typeList = getEnumList("servcType");
                if (typeList != null && typeList.length > 0) {
                    typeList.forEach(function (item) {
                        let queryItem = {};
                        queryItem.value = item.text;
                        queryItem.label = item.text;
                        servcTypeTextList.push(queryItem);
                    });
                    this.servcTypeTextList = Utils.merge([], servcTypeTextList);
                }
            },
            //自动合并数据行
            commonChangeEvent(){
                this.checkData();
            },
            checkData () {
                let self = this;
                let rows = this.servcImpDto.impInfoList.clone();
                let itemLength = rows.length;
                let rowMap = {}; //  key: name_servcTypeName_comnOnlyFlag_specName, value: rowNo
                for (let i = 0; i < itemLength; i++) {
                    let servcImpDto = rows[i];
                    servcImpDto.validateInfo = {
                        name: {validateOk: true},
                        title: {validateOk: true},
                        servcTypeName: {validateOk: true},
                        comnOnlyFlag: {validateOk: true},
                        specName: {validateOk: true},
                        fixedSpec: {validateOk: true},
                        toDoorFee: {validateOk: true},
                        workHourFee: {validateOk: true},
                        generallFee: {validateOk: true},
                        wrntPeriod: {validateOk: true},
                        rspTimeMi: {validateOk: true},
                        arriveTimeMi: {validateOk: true},
                        repairedTimeMi: {validateOk: true},
                        telCallTimeMi: {validateOk: true},
                        accName: {validateOk: true},
                        accSpec: {validateOk: true},
                        accPrice: {validateOk: true},
                        accPrice2: {validateOk: true}
                    };
                    let validateOk = true;
                    // 检查 [服务名称]
                    if (!Utils.isNoB(servcImpDto.name)) {
                        servcImpDto.name = this.replaceSL(servcImpDto.name, ' ');
                    }
                    if (Utils.isNoB(servcImpDto.name)) {
                        validateOk = false;
                        servcImpDto.validateInfo.name = {
                            validateOk: false,
                            errorMsg: "[服务名称]单元不可为空"
                        };
                    } else if (servcImpDto.name.length > 30) {
                        validateOk = false;
                        servcImpDto.validateInfo.name = {
                            validateOk: false,
                            errorMsg: "[服务名称]单元长度最大30，当前[" + servcImpDto.name.length + "]"
                        };
                    }
                    // 服务标题
                    if (!Utils.isNoB(servcImpDto.title)) {
                        servcImpDto.title = this.replaceSL(servcImpDto.title, ' ');
                    }
                    if (Utils.isNoB(servcImpDto.title)) {
                        validateOk = false;
                        servcImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[服务标题]单元不可为空"
                        };
                    } else if (servcImpDto.title.length > 60) {
                        validateOk = false;
                        servcImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[服务标题]单元长度最大60，当前[" + servcImpDto.title.length + "]"
                        };
                    }
                    // 服务类型
                    if (!Utils.isNoB(servcImpDto.servcTypeName)) {
                        servcImpDto.servcTypeName = this.replaceSL(servcImpDto.servcTypeName, ' ');
                    }
                    if (Utils.isNoB(servcImpDto.servcTypeName)) {
                        validateOk = false;
                        servcImpDto.validateInfo.servcTypeName = {
                            validateOk: false,
                            errorMsg: "[服务类型]单元不可为空"
                        };
                    }
                    // 服务用途
                    if (!Utils.isNoB(servcImpDto.comnOnlyFlag)) {
                        servcImpDto.comnOnlyFlag = this.replaceSL(servcImpDto.comnOnlyFlag, ' ');
                    }
                    if (Utils.isNoB(servcImpDto.comnOnlyFlag)) {
                        validateOk = false;
                        servcImpDto.validateInfo.comnOnlyFlag = {
                            validateOk: false,
                            errorMsg: "[服务用途]单元不可为空"
                        };
                    }
                    // 规格名称
                    if (!Utils.isNoB(servcImpDto.specName)) {
                        servcImpDto.specName = this.replaceSL(servcImpDto.specName, ' ');
                    }
                    if (Utils.isNoB(servcImpDto.specName)) {
                        validateOk = false;
                        servcImpDto.validateInfo.specName = {
                            validateOk: false,
                            errorMsg: "[规格名称]单元不可为空"
                        };
                    } else if (servcImpDto.specName.length > 30) {
                        validateOk = false;
                        servcImpDto.validateInfo.specName = {
                            validateOk: false,
                            errorMsg: "[规格名称]单元长度最大30，当前[" + servcImpDto.specName.length + "]"
                        };
                    }
                    // 规格说明
                    if (!Utils.isNoB(servcImpDto.fixedSpec)) {
                        servcImpDto.fixedSpec = this.replaceSL(servcImpDto.fixedSpec, ' ');
                    }
                    if (Utils.isNoB(servcImpDto.fixedSpec)) {
                        validateOk = false;
                        servcImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[规格说明]单元不可为空"
                        };
                    } else if (servcImpDto.fixedSpec.length > 45) {
                        validateOk = false;
                        servcImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[规格说明]单元长度最大45，当前[" + servcImpDto.fixedSpec.length + "]"
                        };
                    }
                    // 上门费(元)
                    if (Utils.isNoB(servcImpDto.toDoorFee)) {
                        validateOk = false;
                        servcImpDto.validateInfo.toDoorFee = {
                            validateOk: false,
                            errorMsg: "[上门费(元)]单元不可为空"
                        };
                    } else if (!Utils.isMoneyStr(servcImpDto.toDoorFee)) {
                        validateOk = false;
                        servcImpDto.validateInfo.toDoorFee = {
                            validateOk: false,
                            errorMsg: "请输入正确的金额"
                        };
                        servcImpDto.toDoorFee = null;
                    } else {
                        servcImpDto.toDoorFee = parseFloat(servcImpDto.toDoorFee).toFixed(2);
                    }
                    // 参考人工费(元)
                    if (!Utils.isNoB(servcImpDto.workHourFee)) {
                        if (!Utils.isMoneyStr(servcImpDto.workHourFee)) {
                            validateOk = false;
                            servcImpDto.validateInfo.workHourFee = {
                                validateOk: false,
                                errorMsg: "请输入正确的金额"
                            };
                            servcImpDto.workHourFee = null;
                        } else {
                            servcImpDto.workHourFee = parseFloat(servcImpDto.workHourFee).toFixed(2);
                        }
                    }
                    // 服务费(元)
                    if (Utils.isNoB(servcImpDto.generallFee)) {
                        validateOk = false;
                        servcImpDto.validateInfo.generallFee = {
                            validateOk: false,
                            errorMsg: "[服务费(元)]单元不可为空"
                        };
                    } else if (!Utils.isMoneyStr(servcImpDto.generallFee)) {
                        validateOk = false;
                        servcImpDto.validateInfo.generallFee = {
                            validateOk: false,
                            errorMsg: "请输入正确的金额"
                        };
                        servcImpDto.generallFee = null;
                    } else {
                        servcImpDto.generallFee = parseFloat(servcImpDto.generallFee).toFixed(2);
                    }
                    // 要求响应时长(分钟)
                    if (Utils.isNoB(servcImpDto.rspTimeMi)) {
                        validateOk = false;
                        servcImpDto.validateInfo.rspTimeMi = {
                            validateOk: false,
                            errorMsg: "[要求响应时长(分钟)]单元不可为空"
                        };
                    } else if (!Utils.isIntStr(servcImpDto.rspTimeMi) || parseInt(servcImpDto.rspTimeMi) < 0) {
                        validateOk = false;
                        servcImpDto.validateInfo.rspTimeMi = {
                            validateOk: false,
                            errorMsg: "请输入正确的数字"
                        };
                        servcImpDto.rspTimeMi = null;
                    }
                    // 要求到达时长(分钟)
                    if (Utils.isNoB(servcImpDto.arriveTimeMi)) {
                        validateOk = false;
                        servcImpDto.validateInfo.arriveTimeMi = {
                            validateOk: false,
                            errorMsg: "[要求到达时长(分钟)]单元不可为空"
                        };
                    } else if (!Utils.isIntStr(servcImpDto.arriveTimeMi) || parseInt(servcImpDto.arriveTimeMi) < 0) {
                        validateOk = false;
                        servcImpDto.validateInfo.arriveTimeMi = {
                            validateOk: false,
                            errorMsg: "请输入正确的数字"
                        };
                        servcImpDto.arriveTimeMi = null;
                    }
                    // 要求维修时长(分钟)
                    if (Utils.isNoB(servcImpDto.repairedTimeMi)) {
                        validateOk = false;
                        servcImpDto.validateInfo.repairedTimeMi = {
                            validateOk: false,
                            errorMsg: "[要求维修时长(分钟)]单元不可为空"
                        };
                    } else if (!Utils.isIntStr(servcImpDto.repairedTimeMi) || parseInt(servcImpDto.repairedTimeMi) < 0) {
                        validateOk = false;
                        servcImpDto.validateInfo.repairedTimeMi = {
                            validateOk: false,
                            errorMsg: "请输入正确的数字"
                        };
                        servcImpDto.repairedTimeMi = null;
                    }
                    // 电话回询时限(分钟)
                    if (Utils.isNoB(servcImpDto.telCallTimeMi)) {
                        validateOk = false;
                        servcImpDto.validateInfo.telCallTimeMi = {
                            validateOk: false,
                            errorMsg: "[电话回询时限(分钟)]单元不可为空"
                        };
                    } else if (!Utils.isIntStr(servcImpDto.telCallTimeMi) || parseInt(servcImpDto.telCallTimeMi) < 0) {
                        validateOk = false;
                        servcImpDto.validateInfo.telCallTimeMi = {
                            validateOk: false,
                            errorMsg: "请输入正确的数字"
                        };
                        servcImpDto.telCallTimeMi = null;
                    }
                    // 要求质保时长(天)
                    if (!Utils.isNoB(servcImpDto.wrntPeriod) && (!Utils.isIntStr(servcImpDto.wrntPeriod) || parseInt(servcImpDto.wrntPeriod) < 0)) {
                        validateOk = false;
                        servcImpDto.validateInfo.wrntPeriod = {
                            validateOk: false,
                            errorMsg: "请输入正确的数字"
                        };
                        servcImpDto.wrntPeriod = null;
                    }
                    // 配件名称
                    if (!Utils.isNoB(servcImpDto.accName)) {
                        servcImpDto.accName = this.replaceSL(servcImpDto.accName, ' ');
                        if (!Utils.isNoB(servcImpDto.accName) && servcImpDto.accName.length > 30) {
                            validateOk = false;
                            servcImpDto.validateInfo.accName = {
                                validateOk: false,
                                errorMsg: "[配件名称]单元长度不能超过30个字符"
                            };
                        }
                    }
                    // 配件规格
                    if (!Utils.isNoB(servcImpDto.accSpec)) {
                        servcImpDto.accSpec = this.replaceSL(servcImpDto.accSpec, ' ');
                        if (!Utils.isNoB(servcImpDto.accSpec) && servcImpDto.accSpec.length > 90) {
                            validateOk = false;
                            servcImpDto.validateInfo.accSpec = {
                                validateOk: false,
                                errorMsg: "[配件规格]单元长度不能超过90个字符"
                            };
                        }
                    }
                    // 价格下限(元)
                    if (!Utils.isNoB(servcImpDto.accPrice)) {
                        if (!Utils.isMoneyStr(servcImpDto.accPrice)) {
                            validateOk = false;
                            servcImpDto.validateInfo.accPrice = {
                                validateOk: false,
                                errorMsg: "请输入正确的金额"
                            };
                            servcImpDto.accPrice = null;
                        } else {
                            servcImpDto.accPrice = parseFloat(servcImpDto.accPrice).toFixed(2);
                        }
                    }
                    // 价格上限(元)
                    if (!Utils.isNoB(servcImpDto.accPrice2)) {
                        if (!Utils.isMoneyStr(servcImpDto.accPrice2)) {
                            validateOk = false;
                            servcImpDto.validateInfo.accPrice2 = {
                                validateOk: false,
                                errorMsg: "请输入正确的金额"
                            };
                            servcImpDto.accPrice2 = null;
                        } else {
                            servcImpDto.accPrice2 = parseFloat(servcImpDto.accPrice2).toFixed(2);
                        }
                    }
                    // 校验重复数据
                    if (Utils.isTrue(servcImpDto.validateInfo.name.validateOk) && Utils.isTrue(servcImpDto.validateInfo.servcTypeName.validateOk) //
                        && Utils.isTrue(servcImpDto.validateInfo.comnOnlyFlag.validateOk) && Utils.isTrue(servcImpDto.validateInfo.specName.validateOk)) {
                        let key = servcImpDto.name + '_' + servcImpDto.servcTypeName + '_' + servcImpDto.comnOnlyFlag + '_' + servcImpDto.specName;
                        let rowNoTmp = rowMap[key];
                        if (rowNoTmp == null) {
                            rowMap[key] = servcImpDto.rowNo;
                        } else {
                            validateOk = false;
                            servcImpDto.validateInfo.name = {
                                validateOk: false,
                                errorMsg: "该行与行号为[" + rowNoTmp + "]服务项目重复请修正"
                            };
                            servcImpDto.validateInfo.servcTypeName = {
                                validateOk: false,
                                errorMsg: "该行与行号为[" + rowNoTmp + "]服务项目重复请修正"
                            };
                            servcImpDto.validateInfo.comnOnlyFlag = {
                                validateOk: false,
                                errorMsg: "该行与行号为[" + rowNoTmp + "]服务项目重复请修正"
                            };
                            servcImpDto.validateInfo.specName = {
                                validateOk: false,
                                errorMsg: "该行与行号为[" + rowNoTmp + "]服务项目重复请修正"
                            };
                        }
                    }
                    //
                    if (Utils.isFalse(validateOk)) {
                        servcImpDto.failed = true;
                        if (Utils.isNoB(servcImpDto.errorMsg)) {
                            servcImpDto.errorMsg = "校验未通过，请按照提示修改数据";
                        }
                    } else {
                        if (Utils.isTrue(servcImpDto.failed) && (Utils.isNoB(servcImpDto.errorMsg) || (!Utils.isNoB(servcImpDto.errorMsg)) && servcImpDto.errorMsg == '校验未通过，请按照提示修改数据')) {
                            servcImpDto.failed = false;
                            servcImpDto.errorMsg = null;
                        }
                    }
                }
                //记录被选中的行
                let oldSelectedRowNos = this.multipleSelection.pluck('rowNo');
                //
                this.servcImpDto.impInfoList = rows;
                this.setPageServcImpInfoList();
                //（必须）延迟恢复被选中的行
                setTimeout(function () {
                    self.servcImpDto.impInfoList.forEach(function (row) {
                        if (oldSelectedRowNos.indexOf(row.rowNo) != -1) {
                            self.$refs.servcImpInfoTable.toggleRowSelection(row);
                        }
                    });
                }, 1000);
            },
            setPageServcImpInfoList: function () {
                let totalRows = this.servcImpDto.impInfoList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                let rows = totalRows.slice(start, end);
                this.pageServcImpList = rows;
                this.totalCount = totalRows.length;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageServcImpInfoList();
            },
            downloadServcImpModel: function () {
                let impInfoList = this.servcImpDto.impInfoList || [];
                if (impInfoList.length <= 0) {
                    MsgBox.warning("没有要导出的数据！");
                    return;
                }
                servcApi.exportServcImpModelUrl(impInfoList, function (result) {
                    if (result.type == 'info') {
                        Utils.downloadFile(getAppUrl(result.data));
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择行
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 批量设置收费项
            setChargeItemBatch: function () {
                let self = this;
                let selectRows = self.multipleSelection || [];
                let rowLen = selectRows.length;
                if (rowLen == 0) {
                    self.$message.warning("请勾选要设置的行！");
                    return;
                }
                let servcTypeNameList = [];
                for (let i = 0; i < rowLen; i++) {
                    let row = selectRows[i];
                    if (!Utils.isNoB(row.servcTypeName) && !servcTypeNameList.contains(row.servcTypeName)) {
                        servcTypeNameList.push(row.servcTypeName);
                    }
                }
                if (servcTypeNameList.length > 1) {
                    self.$message.warning("仅可选择同一服务类型的服务项目！");
                    return;
                } else if (servcTypeNameList.length <= 0) {
                    self.$message.warning("请选择服务类型！");
                    return;
                }
                //
                let servcTypeList = getEnumList("servcType");
                let servcType = servcTypeList.find(function (servcTypeX) {
                    return servcTypeX.text == servcTypeNameList[0];
                });
                let servcTypeId = servcType == null ? null : servcType.value;
                //
                let params = {
                    servcTypeId: servcTypeId
                };
                openServcTypeChargeItemListSelect(params, function (selectList, theDlg) {
                    theDlg.close();
                    let servcChargeItemList = [];
                    if (!Utils.isNoB(selectList) && selectList.length > 0) {
                        for (let i = 0; i < selectList.length; i++) {
                            servcChargeItemList.push({
                                refSrcId: selectList[i].id,
                                chargeName: selectList[i].name,
                                price: selectList[i].price
                            });
                        }
                    }
                    //
                    for (let i = 0; i < rowLen; i++) {
                        let row = selectRows[i];
                        row.servcChargeItemList = Utils.merge([], servcChargeItemList);
                    }
                });
            },
            // 收费项
            selectChargeItem: function (rowNo) {
                let self = this;
                let servcList = self.servcImpDto.impInfoList.clone();
                let servc = servcList.find(function (servcInfo) {
                    return servcInfo.rowNo == rowNo;
                });
                let servcTypeId = null;
                if (!Utils.isNoB(servc.servcTypeName)) {
                    let servcTypeList = getEnumList("servcType");
                    for (let i = 0; i < servcTypeList.length; i++) {
                        let servcType = servcTypeList[i];
                        if (servcType.text == servc.servcTypeName) {
                            servcTypeId = servcType.value;
                        }
                    }
                }
                //
                let servcChargeItemList = servc.servcChargeItemList || [];
                let params = {
                    selectIds: servcChargeItemList.pluck('refSrcId') || [],
                    servcTypeId: servcTypeId
                };
                openServcTypeChargeItemListSelect(params, function (selectList, theDlg) {
                    theDlg.close();
                    servcChargeItemList = [];
                    if (!Utils.isNoB(selectList) && selectList.length > 0) {
                        for (let i = 0; i < selectList.length; i++) {
                            servcChargeItemList.push({
                                refSrcId: selectList[i].id,
                                chargeName: selectList[i].name,
                                price: selectList[i].price
                            });
                        }
                    }
                    servc.servcChargeItemList = Utils.merge([], servcChargeItemList);
                    self.servcImpDto.impInfoList = Utils.merge([], servcList);
                });
            },
            // 检查
            validateServcImpModel: function () {
                this.startFlag = true;
                let self = this;
                let servcImpDto = this.servcImpDto;
                //
                let servcImpInfoList = servcImpDto.impInfoList || [];
                let theLoading = MsgBox.loading("正在处理，请稍后...");
                servcApi.validateServcImpInfo(servcImpInfoList, function (result) {
                    theLoading.hide();
                    servcImpDto.impInfoList = Utils.merge([], result.data);
                    self.servcImpDto = Utils.merge({}, servcImpDto);
                    self.checkData();
                });
            },
            // 检查并导入
            doServcImpModelImport(){
                let self = this;
                let servcImpDto = this.servcImpDto;
                // 判断全部的状态是否是ok
                let servcImpInfoList = servcImpDto.impInfoList || [];
                let srcListLength = servcImpInfoList.length;
                let errFlag = false;
                let errMsg = '';
                for (let i = 0; i < srcListLength; i++) {
                    let srcDeviceImpInfo = servcImpInfoList[i];
                    if (Utils.isTrue(srcDeviceImpInfo.failed)) {
                        errFlag = true;
                        MsgBox.warning("校验未通过，请修改导入数据！");
                        break;
                    }
                    let servcChargeItemList = srcDeviceImpInfo.servcChargeItemList || [];
                    if (servcChargeItemList.length <= 0) {
                        errFlag = true;
                        if (Utils.isNoB(errMsg)) {
                            errMsg = '校验未通过，行号为' + srcDeviceImpInfo.rowNo;
                        } else {
                            errMsg = errMsg + '、’' + srcDeviceImpInfo.rowNo;
                        }
                    }
                }
                if (errFlag) {
                    if (!Utils.isNoB(errMsg)) {
                        errMsg = errMsg + '的服务项目没有选择收费项！';
                        MsgBox.warning(errMsg);
                    }
                    return;
                }
                if (srcListLength > 500) {
                    //弹出确认框
                    this.$confirm('数据较多,将会执行一段时间,请勿关闭此页面或关闭浏览器,确定导入吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        self.doServcImpModelImport();
                    }).catch(function () {

                    });
                } else {
                    self.doServcImpModelImport();
                }
            },
            doServcImpModelImport(){
                let self = this;
                let servcImpDto = this.servcImpDto;
                let impInfoList = servcImpDto.impInfoList || [];
                let theLoading = MsgBox.loading("正在处理，请稍后...");
                servcApi.doServcImpInfoImport(impInfoList, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        self.$emit('other-close');
                    } else {
                        MsgBox.warning(result.message);
                    }
                    //
                    return;
                });
            },
            replaceSL(str, char){
                if (!Utils.isNoB(str)) {
                    str = Utils.replace(str, '\r\n', char);
                    str = Utils.replace(str, '\r', char);
                    str = Utils.replace(str, '\n', char);
                }
                return str;
            }
        }
    }
</script>

<style>
    .el-table .selected-row {
        background: #c9e5f5;
    }
</style>



// WEBPACK FOOTER //
// src/compo/servc/ServcImpCheck.vue